export default __webpack_public_path__ + "static/media/image-cover.4c3526de.png";